<template>
    <el-dialog width="40%" :visible.sync="hereShow" :title="$t('ita_add_qa')" v-loading="loading">
        <div class="content">
            <el-input :placeholder="$t('ENTER_SEARCH_CONTENT')" v-model="filterText"> </el-input>
            <el-tree
                ref="entityTree"
                :default-expand-all="true"
                :expand-on-click-node="false"
                :check-strictly="true"
                :data="bindData"
                class="treeWithEntity"
                :props="{
                    children: 'childEntity',
                    label: 'entityName'
                }"
                :filter-node-method="treeFilterNode"
                show-checkbox
                node-key="id"
                @check="handleTreeCheckChange"
            >
                <span class="entity-list-tree-node" slot-scope="{ node, data }">
                    <span :title="node.label" @click="activeNode(data)">{{ node.label }}</span>
                    <span class="extra-area" v-if="data.childEntity.length > 0">
                        <a v-if="!isSelectAll(data)" @click="clickAll(data, true)">{{ $t('select_all') }}</a>
                        <a v-else @click="clickAll(data, false)">{{ $t('unselect_all') }}</a>
                    </span>
                </span>
            </el-tree>
        </div>
        <div class="dialog-footer" slot="footer">
            <el-button class="cancel-btn" @click="hereShow = false">{{ $t('btn_cancel') }}</el-button>
            <el-button class="wl-green" @click="onSaveClick">{{ $t('btn_save') }}</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'AddQuestionnaire',
    data() {
        return {
            hereShow: false,
            filterNodeList: [],
            filterText: '',
            loading: false
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        bindData: {
            type: Array,
            default: () => []
        },
        handleSave: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        async onSaveClick() {
            this.loading = true
            await this.handleSave(this.$refs.entityTree.getCheckedNodes())
            this.loading = false
        },
        treeFilterNode(value, data) {
            if (!value) return true

            let isShow = data.entityName.toLowerCase().indexOf(value.toLowerCase()) !== -1
            if (isShow) {
                this.filterNodeList.push(data)
            }
            return isShow
        },
        handleTreeCheckChange(node, checkInfo) {
            node.checked = checkInfo.checkedKeys.indexOf(node.id) !== -1
        },
        activeNode(node) {
            if (!node.disabled) {
                node.checked = !node.checked
                this.$refs.entityTree.setChecked(node.id, node.checked, false)
            }
        },
        isSelectAll(data) {
            //判断当前node是否全部选中
            let flag = data.disabled || data.checked
            if (flag && data.childEntity.length > 0) {
                flag = data.childEntity.every((item) => {
                    return item.disabled || item.checked
                })
                if (flag) {
                    let flagArr = []
                    for (let i = 0; i < data.childEntity.length; i++) {
                        if (data.childEntity[i].childEntity.length > 0) {
                            flagArr[i] = data.childEntity[i].childEntity.every((item) => {
                                return item.disabled || item.checked
                            })
                        }
                    }
                    flag = flagArr.every((item) => item === true)
                }
            }
            return flag
        },
        clickAll(data, checked) {
            if (this.filterText.length > 0) {
                this.fileterClickAll(data, checked)
            } else {
                if (!data.disabled) {
                    this.$refs.entityTree.setChecked(data.id, checked, false)
                    data.checked = checked
                }
                if (data.childEntity.length > 0) {
                    data.childEntity.forEach((child) => this.clickAll(child, checked))
                }
            }
        },
        fileterClickAll(data, checked) {
            let temp = []
            if (data.entityType === 'ROOT') {
                temp.push(data.id)
                this.filterNodeList.forEach((item) => {
                    temp.push(item.id)
                    temp.push(item.parentKey)
                })
                this.iteratorTree(data, checked, temp)
            } else {
                // Entity
                if (!data.disabled) {
                    this.$refs.entityTree.setChecked(data.id, checked, false)
                    data.checked = checked
                }
                if (data.childEntity.length > 0) {
                    for (let i = 0; i < data.childEntity.length; i++) {
                        if (
                            data.childEntity[i].entityName.toLowerCase().indexOf(this.filterText.toLowerCase()) != -1 &&
                            !data.childEntity[i].disabled
                        ) {
                            this.$refs.entityTree.setChecked(data.childEntity[i].id, checked, false)
                            data.childEntity[i].checked = checked
                        }
                    }
                }
            }
        },
        iteratorTree(data, checked, idList) {
            if ((idList.indexOf(data.id) != -1 || idList.indexOf(data.key) != -1) && !data.disabled) {
                this.$refs.entityTree.setChecked(data.id, checked, false)
                data.checked = checked
            }
            if (data.childEntity.length > 0) {
                data.childEntity.forEach((child) => this.iteratorTree(child, checked, idList))
            }
        }
    },
    watch: {
        show(v) {
            this.hereShow = v
        },
        hereShow(v) {
            this.$emit('update:show', v)
            if (!v) {
                this.filterText = ''
            }
        },
        filterText(val) {
            this.filterNodeList = []
            this.$refs.entityTree.filter(val)
        }
    }
}
</script>